import GamepageTemplate from "../components/containers/GamepageTemplate";
import { globalAllowLeaderboards } from "..";

const BurninRubber5A = () =>{
    return(
        <GamepageTemplate 
            backgroundPng={"5a"}
            gameTitle={"Burnin' Rubber 5A"}
            gameDescription={"Burn some rubber and unlock brand new vehicles in this explosive iteration of Burnin' Rubber 5"}
            embedYouTubeId={"notVGyCyn6Y?si=LakKZBG-9oy1wJM-"}
            downloadPath={"https://drive.google.com/uc?id=130VoKCY05N9cKa2RlBd3gF62Se1EXA85"}
            betaDownload={"https://drive.google.com/uc?id=1MQR8I1dDm-0GYXsYchZldq8pxLBWh5nV"}
            gameVersion={"2.2.2"}
            versionDate={"2025-05"}
            allowBeta={false}
            betaVersion={"2.2.1"}
            allowLeaderboards={globalAllowLeaderboards}
            leaderboardsPath={"/5a/leaderboards"}
        />  
    );
};

export default BurninRubber5A;
